import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Times } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { addAddress, deleteAddress, fetchCountries, updateAddress } from '../actions';
import { selectCountries, selectUserPropertyNames } from '../selectors';
import { selectAddressTypes } from '../../Address/selectors';
import { Dropdown } from '../../../components/Dropdown';
import { FieldError } from '../../../components/FieldError';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';
import { Loader } from '../../../components/Loader';
const STATE = {
  edit: null,
  value: '',
  addUserAddress: false,
  addValue: '',
  deleteAddressConfirm: null,
  addCountryId: null,
  address: { countryId: null, typeId: null },
  fieldErrors: null,
};

const Container = styled.div``;

const Address = styled.div`
  margin: 6px;
  border: 1px solid #ddd;
  padding: 12px 12px 0;

  .button {
    margin: 0 -12px;
  }
  .name {
    width: 200px;
    text-transform: uppercase;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class UserAddressesComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchCountries();
  }

  editAddress(address) {
    this.setState({ edit: address.id, address });
  }

  reset() {
    this.setState({ ...STATE });
  }

  get user() {
    return this.props.user;
  }

  get address() {
    return this.props.address ?? {};
  }

  get countries() {
    return this.props.countries;
  }

  get locale() {
    return this.props.locale;
  }

  get addressTypes() {
    return this.props.addressTypes;
  }

  get nameFieldErrors() {
    return this.state.fieldErrors?.name;
  }

  get typeIdFieldErrors() {
    return this.state.fieldErrors?.typeId;
  }

  get countryIdFieldErrors() {
    return this.state.fieldErrors?.countryId;
  }

  get cityFieldErrors() {
    return this.state.fieldErrors?.cityId;
  }

  get postcodeFieldErrors() {
    return this.state.fieldErrors?.postcode;
  }

  get addressLine1FieldErrors() {
    return this.state.fieldErrors?.addressLine1;
  }

  get addressLine2FieldErrors() {
    return this.state.fieldErrors?.addressLine2;
  }

  addAddress() {
    const userId = this.props.user.id;

    this.props.addAddress(userId, this.state.address, this.handleResponse.bind(this));
  }

  handleResponse(data) {
    let { result, validationErrors } = data;
    if (result === true) {
      return;
    }

    if (validationErrors && validationErrors.length > 0) {
      const errors = data.validationErrors.reduce((prev, curr) => {
        prev[curr.property] = Object.values(curr.constraints);
        return prev;
      }, {});
      this.setState(prev => {
        return { ...prev, fieldErrors: errors };
      });
    }
  }

  updateAddress() {
    const { id, name, postcode, addressLine1, addressLine2, city, countryId, typeId } = this.state.address;

    const addressDto = {
      name,
      postcode,
      addressLine1,
      addressLine2,
      city,
      countryId,
      typeId,
    };

    const addressId = id;

    this.props.updateAddress(addressId, addressDto, this.reset.bind(this));
  }

  deleteAddress() {
    const { addressId, userId } = this.state.deleteAddressConfirm;

    this.props.deleteAddress(addressId, this.reset.bind(this));
  }

  render() {
    if (this.props.work) return <Loader />;
    const user = this.props.user;
    if (!this.countries || !this.countries.length) return null;
    if (!this.addressTypes || !this.addressTypes.length) return null;

    return (
      <Container>
        {this.renderAdd()}

        <VBox>{user?.addresses?.map(a => this.renderAddress(a))}</VBox>

        <Button onClick={this.setStateFn({ addUserAddress: true })}>+ {this.lbl('add')}</Button>
        {this.renderDeleteAddress()}
      </Container>
    );
  }

  renderAdd() {
    if (true !== this.state.addUserAddress) {
      return null;
    }
    const countriesOptions = this.countries?.map(c => {
      return { value: c.id, label: translateCountry(c.name, this.locale) };
    });
    const addressTypes = this.addressTypes?.map(t => {
      return { value: t.id, label: t.name };
    });
    const selectedCountry = countriesOptions.find(o => o.value === this.state?.address?.countryId);
    const selectedAddressType = addressTypes.find(o => o.value === this.state?.address?.typeId);

    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('user.property.add')}>
        <div>
          <div>Name</div>
          <FormField>
            <Input name="name" onChange={this.onAddressInputChange.bind(this)} />
            <FieldError errors={this.nameFieldErrors} />
          </FormField>
        </div>
        <div>
          <div>Type</div>
          <Dropdown
            name="typeId"
            options={addressTypes}
            value={selectedAddressType}
            onChange={this.onAddressTypeChange.bind(this)}
          />
          <FieldError errors={this.typeIdFieldErrors} />
        </div>
        <div>
          <div>Country</div>
          <Dropdown
            name="countryId"
            options={countriesOptions}
            value={selectedCountry}
            onChange={this.onAddressCountryChange.bind(this)}
          />
          <FieldError errors={this.countryIdFieldErrors} />
        </div>
        <div>
          <div>City</div>
          <FormField>
            <Input name="city" onChange={this.onAddressInputChange.bind(this)} />
            <FieldError errors={this.cityFieldErrors} />
          </FormField>
        </div>
        <div>
          <div>Postcode</div>
          <FormField>
            <Input name="postcode" onChange={this.onAddressInputChange.bind(this)} />
            <FieldError errors={this.postcodeFieldErrors} />
          </FormField>
        </div>
        <div>
          <div>Address line 1</div>
          <FormField>
            <Input name="addressLine1" onChange={this.onAddressInputChange.bind(this)} />
            <FieldError errors={this.addressLine1FieldErrors} />
          </FormField>
        </div>
        <div>
          <div>Address line 2</div>
          <FormField>
            <Input name="addressLine2" onChange={this.onAddressInputChange.bind(this)} />
            <FieldError errors={this.addressLine2FieldErrors} />
          </FormField>
        </div>
        <ModalControls>
          <Button primary onClick={this.addAddress.bind(this)}>
            Save
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderEditAddress(address) {
    if (this.state.edit !== address.id) {
      return null;
    }

    const countriesOptions = this.countries?.map(c => {
      return { value: c.id, label: translateCountry(c.name, this.locale) };
    });
    const addressTypes = this.addressTypes?.map(t => {
      return { value: t.id, label: t.name };
    });

    const selectedCountry = countriesOptions.find(o => o.value === this.state?.address?.countryId);
    const selectedAddressType = addressTypes.find(o => o.value === this.state?.address?.typeId);

    return (
      <Modal key={address.id} onClose={this.reset.bind(this)} title={this.lbl('user.property.add')}>
        <div>
          <div>Name</div>
          <FormField>
            <Input name="name" value={this.state.address.name} onChange={this.onAddressInputChange.bind(this)} />
          </FormField>
          <FieldError errors={this.vehicleTypeErrors} />
        </div>
        <div>
          <div>Type</div>
          <Dropdown
            name="typeId"
            options={addressTypes}
            onChange={this.onAddressTypeChange.bind(this)}
            value={selectedAddressType}
          />
        </div>
        <div>
          <div>Country</div>
          <Dropdown
            name="countryId"
            options={countriesOptions}
            onChange={this.onAddressCountryChange.bind(this)}
            value={selectedCountry}
          />
        </div>
        <div>
          <div>City</div>
          <FormField>
            <Input name="city" value={this.state.address.city} onChange={this.onAddressInputChange.bind(this)} />
          </FormField>
        </div>
        <div>
          <div>Postcode</div>
          <FormField>
            <Input name="postcode" value={this.state.address.postcode} onChange={this.onAddressInputChange.bind(this)} />
          </FormField>
        </div>
        <div>
          <div>Address line 1</div>
          <FormField>
            <Input
              name="addressLine1"
              value={this.state.address.addressLine1}
              onChange={this.onAddressInputChange.bind(this)}
            />
          </FormField>
        </div>
        <div>
          <div>Address line 2</div>
          <FormField>
            <Input
              name="addressLine2"
              value={this.state.address.addressLine2}
              onChange={this.onAddressInputChange.bind(this)}
            />
          </FormField>
        </div>
        <ModalControls>
          <Button primary onClick={this.updateAddress.bind(this)}>
            {this.lbl('save')}
          </Button>

          <Button warning onClick={this.setStateFn({ deleteAddressConfirm: { addressId: address.id } })}>
            <Times /> {this.lbl('delete')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderAddress(address) {
    if (this.state.edit === address.id) return this.renderEditAddress(address);
    return (
      <Address key={`${address.id}`} onClick={() => this.editAddress(address)}>
        <VBox left>
          <h3 className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</h3>
          <div>{address.type?.name}</div>
          <div>{address.addressLine1}</div>
          <div>{address.addressLine2}</div>

          <div>{address.zipcode}</div>

          <div>{address.city}</div>

          <div>{translateCountry(address.country?.name, this.locale)}</div>
        </VBox>
      </Address>
    );
  }

  renderDeleteAddress() {
    if (!this.state.deleteAddressConfirm) return null;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('user.modal.delete.confirm.title')}>
        <ModalControls>
          <Button isPrimary onClick={this.deleteAddress.bind(this)}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  onAddressInputChange(evt) {
    const { name, value } = evt.target;
    this.setState((prev, props) => {
      return { ...prev, address: { ...prev.address, [name]: value } };
    });
    return this;
  }

  onAddressCountryChange(evt) {
    const { value } = evt;
    this.setState((prev, props) => {
      return { ...prev, address: { ...prev.address, countryId: value } };
    });
    return this;
  }

  onAddressTypeChange(evt) {
    const { value } = evt;
    this.setState((prev, props) => {
      return { ...prev, address: { ...prev.address, typeId: value } };
    });
    return this;
  }
}

UserAddressesComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    userPropertyNames: selectUserPropertyNames(),
    countries: selectCountries(),
    addressTypes: selectAddressTypes(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addAddress(userId, addressDto, callback) {
      dispatch(addAddress(userId, addressDto, callback));
    },
    updateAddress(addressId, addressDto, callback) {
      dispatch(updateAddress(ownProps.user.id, addressId, addressDto, callback));
    },
    deleteAddress(addressId, callback) {
      dispatch(deleteAddress(ownProps.user.id, addressId, callback));
    },
    fetchCountries() {
      dispatch(fetchCountries());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserAddresses = compose(withConnect, withRouter)(UserAddressesComp);
